import { inject, injectable } from "inversify";
import { ICPLLegalEntitiesClient, LegalEntityModel } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface ILegalEntitiesService {
  getLegalEntities(): Promise<LegalEntityModel[]>;
}

@injectable()
export class LegalEntitiesService implements ILegalEntitiesService {
  @inject(SERVICE_TYPES.CPLLegalEntitiesClient) cplLegalEntitiesClient!: ICPLLegalEntitiesClient;

  async getLegalEntities(): Promise<LegalEntityModel[]> {
    return this.cplLegalEntitiesClient.getLegalEntities(false);
  }
}
